module.exports = __webpack_public_path__ + "img/m_a.d7c6b9e6.png";